import { BackgroundJobsDrawer } from "components/BackgroundJobsDrawer/BackgroundJobsDrawer";
import { useGetAmendedReviewsByFileIdQuery } from "services/ar-screening-api";
import { useGetCostProjectionsByFileIdQuery } from "services/cost-projection-api";
import { useGetMSAByFileIdQuery } from "services/msa-api";
import type {
  AmendedReviewScreeningType,
  CostProjectionDataType,
  MSADataType,
} from "types/DataTypes";
import { useToken } from "utils/context";

type FutureMedicalBackgroundJobsProps = {
  fileId: string | number | undefined;
};

/**
 * wrapper component for BackgroundJobsDrawer that handles
 * future-medical specific filter logic (MSA, Cost Projection, Amended Review)
 */
export const FutureMedicalBackgroundJobs = ({
  fileId: fileIdProp,
}: FutureMedicalBackgroundJobsProps) => {
  const { accessToken } = useToken();
  const fileId = String(fileIdProp ?? "");

  const { data: msaList } = useGetMSAByFileIdQuery(
    { fileId },
    { skip: !accessToken || !fileId },
  );

  const { data: costProjections } = useGetCostProjectionsByFileIdQuery(
    { fileId },
    { skip: !accessToken || !fileId },
  );

  const { data: amendedReviewScreenings } = useGetAmendedReviewsByFileIdQuery(
    { fileId },
    { skip: !accessToken || !fileId },
  );

  const filters = {
    msa_id:
      msaList?.results?.map((msa: MSADataType) => msa.id.toString()) ?? [],
    cost_projection_id:
      costProjections?.results?.map((cp: CostProjectionDataType) =>
        cp.id.toString(),
      ) ?? [],
    amended_review_screening_id:
      amendedReviewScreenings?.results?.map((ar: AmendedReviewScreeningType) =>
        ar.id.toString(),
      ) ?? [],
  };

  return <BackgroundJobsDrawer filters={filters} />;
};

export default FutureMedicalBackgroundJobs;
